import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import restaurantReducer from "./restaurants";
import cartReducer from "./cart";
import logger from "redux-logger"
import sessionReducer from "./session";
import stripeReducer from "./stripe";
import orderReducer from "./order";
import couponReducer from "./coupons";
import freeitemsReducer from "./freeitems";
import waitlistReducer from "./waitlist";

const rootReducer = combineReducers({
  // add reducer functions here
  restaurant: restaurantReducer,
  cart: cartReducer,
  stripe: stripeReducer,
  coupons: couponReducer,
  freeitems: freeitemsReducer,
  waitlist: waitlistReducer
});

let enhancer;

if (process.env.NODE_ENV === "production") {
  enhancer = applyMiddleware(thunk);
} else {
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  enhancer = composeEnhancers(applyMiddleware(thunk, logger));
}

const configureStore = (preloadedState) => {
  return createStore(rootReducer, preloadedState, enhancer);
};

export default configureStore;
